import React from 'react';
import { cn } from '../utils';

const LiveSyncIndicator = ({ isSyncing, variant = 'indigo' }) => {
  const variants = {
    purple: 'bg-purple-400',
    green: 'bg-green-400',
    indigo: 'bg-brand-indigo',
    orange: 'bg-brand-accent',
    emerald: 'bg-emerald-500'
  };

  const dotColor = variants[variant] || variants.indigo;

  return (
    <div className="flex items-center gap-2 px-1">
      <div className={cn(
        "w-2 h-2 rounded-full shadow-sm transition-all duration-500",
        isSyncing ? `${dotColor} animate-pulse shadow-[0_0_8px_rgba(0,0,0,0.2)]` : "bg-emerald-500 shadow-[0_0_8px_rgba(52,211,153,0.4)]"
      )} />
      <span className="text-[10px] font-bold uppercase tracking-[0.2em] text-gray-400">
        {isSyncing ? 'Syncing...' : 'Live Sync active'}
      </span>
    </div>
  );
};

export default LiveSyncIndicator;
